// @flow
import React from 'react';
import classNames from 'classnames';
import randomId from '../../../../javascripts/utils/random-id';

export type Props = {
  options: Array<{ value: string, text: string }>,
  color?: string,
  id?: string,
  className?: string,
  'aria-label'?: string,
  onChange?: (event: SyntheticEvent<HTMLSelectElement>) => void,
  value?: string,
};

const Select = (props: Props): React$MixedElement => {
  const { options, color, ...rest } = props;
  const selectId = rest.id || `select--${randomId()}`;
  return (
    <select
      {...rest}
      id={selectId}
      className={classNames(
        'select',
        color && `select--${color}`,
        rest.className
      )}
    >
      <option className="select__hint" disabled={true} value="">
        Auswählen
      </option>
      {options &&
        options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
    </select>
  );
};

export default Select;
